import { Search } from '@ts/components/Search';

//search-go-btn

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
    setNavSearch();
}

const setInteractiveElements = () => {
    setPageSearch();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSettle', setInteractiveElements);
}

const redirectToSearchResults = (query) => {
    const searchEndpoint = document.getElementById('searchNavTrigger')?.getAttribute('href');
    if (searchEndpoint) {
        window.location.href = `${searchEndpoint}?query=${encodeURIComponent(query)}`;
    }
}

const setPageSearch = () => {
    const searchClear = document.querySelector('.search-page .search-clear-btn');
    const searchInput = document.querySelector('#search-page-input');
    if (!searchClear || !searchInput) return;

    searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchInput.dispatchEvent(
            new Event('input', { bubbles: true })
        );
        searchInput.focus();
    });
}

const setNavSearch = () => {
    const searchInput = document.querySelector('.nav-search input[data-search-autocomplete-url]');
    if (!searchInput) return;

    const autocompleteUrl = searchInput?.getAttribute('data-search-autocomplete-url')?.trim();

    Search.create('#searchNavTrigger', {
        autocompleteUrl: autocompleteUrl || undefined,
        autocompleteDelay: 300,
        onResults: (data) => {
            const searchResults = data.results || [];
            const resultsContainer = document.getElementById("search-results");
            if (!resultsContainer) return;

            if (!data.query || data.query.trim().length === 0) {
                resultsContainer.innerHTML = "";
                return;
            }

            resultsContainer.innerHTML = "";
            if (searchResults.length === 0) {
                resultsContainer.innerHTML = "<div class='no-results'>No results have been found</div>";
                return;
            }

            searchResults.forEach(result => {
                const resultElement = document.createElement("a");
                resultElement.href = result.url;
                resultElement.classList.add("search-result-item");
                resultElement.innerHTML = `${result.name} <i class="fa-solid fa-up-right-from-square"></i>`;

                resultsContainer.appendChild(resultElement);
            });
        }
    });
}